import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class CarteiraAutocompleteMapper {

public map(filter: any) {
    if (filter.carteiraId) {
      const carteiraValue = filter.carteiraId.match(/^[^|]+/)?.[0] ?? '';
      if (filter.carteiraId.includes('|GRUPO')) {
        filter.grupoCarteiraId = carteiraValue;
        filter.carteiraId = '';
      } else {
        filter.carteiraId = carteiraValue;
      }
    }
  }
  public removePipe(text: any): any {
    return text.match(/^[^|]+/)?.[0] ?? '';
  }
}
